import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";


const DeleteRoleAPI = async (data) => {
    const user = useAuth()
    const url = APIURL + "/admin/deleterole"
    return await axios.post(url, { access_token: user.token, ...data })
}

export default DeleteRoleAPI